import { render, staticRenderFns } from "./Vacancy.vue?vue&type=template&id=ec21f356&scoped=true"
import script from "./Vacancy.vue?vue&type=script&lang=js"
export * from "./Vacancy.vue?vue&type=script&lang=js"
import style0 from "./Vacancy.vue?vue&type=style&index=0&id=ec21f356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec21f356",
  null
  
)

export default component.exports